import { useEffect } from 'react';

interface Props {
  checkout_url: string;
}

export default function Redirect({ checkout_url }: Props) {
  useEffect(() => {
    // Redirect to Stripe checkout immediately
    window.location.href = checkout_url;
  }, [checkout_url]);

  return (
    <div className="min-h-screen bg-muted flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-background py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
            <p className="mt-4 text-sm text-muted-foreground">
              Redirecionando para o checkout...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}